// extracted by mini-css-extract-plugin
export default {"container":"CommonFullPageLoader_container__4Xau8"};